export default getText => key =>
  ({
    btnLabel: getText('Next', 'Auth_Reset_OTP_Form'),
    error: getText('Wrong OTP', 'Auth_Reset_OTP_Form'),
    passwordAlreadyUsed: getText(
      'Your new password has been used too recently',
      'Auth_Reset_OTP_Form'
    ),
    otpExpired: getText('OTP Expired', 'Auth_Reset_OTP_Form'),
    resendBtn: getText('Resend OTP', 'Auth_Reset_OTP_Form'),
    resendSuccess: getText('OTP sent successfully', 'Auth_Reset_OTP_Form'),
    resendError: getText('Failed to send OTP', 'Auth_Reset_OTP_Form'),
    resendCooldown: getText('Please wait {seconds}s before resending', 'Auth_Reset_OTP_Form'),
    sending: getText('Sending...', 'Auth_Reset_OTP_Form'),
    didntReceive: getText("Didn't receive the code?", 'Auth_Reset_OTP_Form'),
  }[key])
